import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_UNIVERSAL } from "./abstract/universalAbstract";

const _action = `${ACTION_PREFIX_UNIVERSAL}_update_label`;
const _header = `Update node label`;

export const nodeUpdateLabel = (root, id, label) => {
  const _payload = nodeUpdateLabelLogic(root, id, label);

  logger.logAction(_action, _payload, ACTION_PREFIX_UNIVERSAL);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const nodeUpdateLabelLogic = (root, id, label) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  nodeUtils.setLabel(_node, label);

  return generatePayload(_nodeBackup, _index, _nodeParent, nodeUtils.getLabel(_node));
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, labelAfter) => {
  return {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    name: 'Update node label',
    time: systemUtils.getTimestamp(),
    header: _header,
    description: `Update node label '${nodeUtils.getName(node)}'.`,
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    labelBefore: nodeUtils.getLabel(node) ?? "",
    labelAfter: labelAfter,
  };
};
